import React, {SyntheticEvent, useContext, useState} from "react";
import {IconButton, Tooltip, Typography} from "@mui/material";
import {DeleteRounded} from "@mui/icons-material";
import {useMutation} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {fetchExpiredAttachmentsDelete} from "../../services/http.services";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import CustomLoader from "../../../../util/component/CustomLoader";
import ExpiredCustomDialog from "../dialog/ExpiredCustomDialog";

const DeleteAttachment = ({id, postAction}: {id: string, postAction: any}) => {
   
    const {t} = useTranslation(['expiredManagement', 'translation']);
    const {dispatchGlobalData} = useContext(GlobalContext);

    const [openDialog, setOpenDialog] = useState(false);

    const viewErrorMessage = (message: string, type = snackbarTypes.error) => {
        dispatchGlobalData({
            type: 'SET_SNACKBAR',
            payload: {
                snackbar: {
                    message: t(message, t('common.message.error.tryLater')),
                    type: type,
                    show: true,
                    autoClose: true,
                }
            }
        });
    }

    const fetchExpiredAttachmentsUploadMutation = useMutation(
        fetchExpiredAttachmentsDelete,
        {
            onSuccess: async (response) => {
                if (!!postAction) {
                    postAction();
                }
            },
            onError: (error: any) => {
                viewErrorMessage(`common.message.error.deleteAttachment.${error?.response?.status}`);
            }
        });

    const handleDeleteAttachment = (e: SyntheticEvent) => {
        e.stopPropagation();

        setOpenDialog(true);
    }

    const onClose = () => {

        setOpenDialog(false);
    }

    const deleteAttachment = () => {

        if (!!id) {
            fetchExpiredAttachmentsUploadMutation.mutate(id);
        }

        setOpenDialog(false);
    }

    return (
        <>
            <Tooltip title={t('common.button.delete')} arrow>
                <IconButton color={'secondary'} onClick={handleDeleteAttachment}>
                    <DeleteRounded />
                </IconButton>
            </Tooltip>

            <ExpiredCustomDialog 
                open={openDialog}
                contentDescription={
                    <Typography color="primary" variant="body1">
                        {t('common.message.dialog.deleteAttachment')}
                    </Typography>
                }
                buttonCloseDescription={t('common.button.cancel')}
                buttonConfirmDescription={t('common.button.confirm')}
                onClose={onClose}
                onConfirm={deleteAttachment}
            />
            <CustomLoader loading={fetchExpiredAttachmentsUploadMutation.isLoading} />
        </>
    )
}

export default DeleteAttachment;